/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useImperativeHandle } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, Box, Checkbox, TextField, Tab, Typography, InputAdornment } from "@mui/material";
import clsx from "clsx";
import { Row, Col } from "antd";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { openInvoicesHead, openCreditsHead, settledInvoicesHead, settledCreditsHead } from "../../../../../config/constant";
import moment from 'moment';
import { currencyFormat } from "../../../../../helpers/utilities";
import { useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";


export const CustomerSettlementTable = React.forwardRef((props, ref) => {
    const { requestOISort, requestOPSort, requestCISort, sortOIOrder, sortOIBy,
        sortOPOrder, sortOPBy, sortCIOrder, sortCIBy, settleAmountFunction,
        loadMoreOpenInvoiceTask,
        loadMoreOpenPaymentTask,
        oILoadMore, oILoadMoreContent,
        oPLoadMore, oPLoadMoreContent,
        settleFunction, reverseFunction,
        customerDetails, handleWarningMsg,
        setReversed, openInvoiceDetails, openPaymentDetails, closeInvoiceLoader,
        closeInvoiceDetails, closePaymentDetails } = props;
    const { createDetails } = useSelector(state => state.crudReducer);
    const [OIselected, setOISelected] = useState([]);
    const [OPselected, setOPSelected] = useState([]);
    const [CIselected, setCISelected] = useState([]);
    const [CPselected, setCPSelected] = useState([]);

    const [OIMarkedAmount, setOIMarkedAmount] = useState(0);
    const [OPMarkedAmount, setOPMarkedAmount] = useState(0);
    const [CIMarkedAmount, setCIMarkedAmount] = useState(0);
    const [CPMarkedAmount, setCPMarkedAmount] = useState(0);
    const [value, setValue] = useState(1);
    const prevCreateDetails = usePrevious(createDetails);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOIClick = (e, data, i) => {
        const selectedIndex = OIselected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(OIselected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(OIselected.slice(1));
        } else if (selectedIndex === OIselected.length - 1) {
            newSelected = newSelected.concat(OIselected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                OIselected.slice(0, selectedIndex),
                OIselected.slice(selectedIndex + 1),
            );
        }
        setOISelected(newSelected);
        settleFunction(newSelected, OPselected);
        calculatePayment(e, data, i, 'openInvoice');
    }

    const handleOPClick = (e, data, i) => {
        const selectedIndex = OPselected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(OPselected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(OPselected.slice(1));
        } else if (selectedIndex === OPselected.length - 1) {
            newSelected = newSelected.concat(OPselected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                OPselected.slice(0, selectedIndex),
                OPselected.slice(selectedIndex + 1),
            );
        }
        setOPSelected(newSelected);
        settleFunction(OIselected, newSelected);
        calculatePayment(e, data, i, 'openPayment');
    }

    useImperativeHandle(ref, () => ({
        onEmpty() {
            emptyState();
        }
    }));


    const handleCIClick = (e, data, paymentData) => {
        const selectedIndex = CIselected.indexOf(data.invoiceId + '_' + paymentData.paymentId);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(CIselected, data.invoiceId + '_' + paymentData.paymentId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(CIselected.slice(1));
        } else if (selectedIndex === CIselected.length - 1) {
            newSelected = newSelected.concat(CIselected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                CIselected.slice(0, selectedIndex),
                CIselected.slice(selectedIndex + 1),
            );
        }
        setCISelected(newSelected);
        let s = [], p = [];
        newSelected && newSelected.map((element, i) => {
            let e = element.split("_");
            s.push(parseInt(e[0]));
            p.push(parseInt(e[1]));
        });
        setCPSelected(p);
        reverseFunction(newSelected);
        calculateOpenMarkedAmount([], [], s, closeInvoiceDetails.filter(function (el) { return p.find(e => e === el.paymentId) }));
    }

    const handleCPClick = (e, data) => {
        const selectedIndex = CPselected.indexOf(data.paymentId);
        let newSelected = [], invoicesId = [];

        data.invoices && data.invoices.length > 0 && data.invoices.map(function (element, i) {
            invoicesId.push(element.invoiceId + '_' + data.paymentId);
        });

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(CPselected, data.paymentId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(CPselected.slice(1));
        } else if (selectedIndex === CPselected.length - 1) {
            newSelected = newSelected.concat(CPselected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                CPselected.slice(0, selectedIndex),
                CPselected.slice(selectedIndex + 1),
            );
        }
        setCPSelected(newSelected);
        let s = [], c = [];

        let selectetArray = closeInvoiceDetails.filter(function (el) { return newSelected.find(e => e === el.paymentId) });
        selectetArray && selectetArray.map(function (element, i) {
            element.invoices.map(function (e, i) {
                s.push(e.invoiceId + '_' + element.paymentId);
            });

        });
        s && s.map(function (element, i) {
            let e = element.split("_");
            c.push(parseInt(e[0]));
        });
        setCISelected(s);
        reverseFunction(s);
        calculateOpenMarkedAmount([], [], c, closeInvoiceDetails.filter(function (el) { return newSelected.find(e => e === el.paymentId) }));
    }


    const setClosedTransaction = () => {
        setReversed(false);
        emptyState();
        handleWarningMsg(true);
    }

    const setOpenTransaction = () => {
        setReversed(true);
        emptyState();
        handleWarningMsg(false);
    }

    const handleCostAmount = (e, data, costIndex) => {
        calculatePayment(e, data, costIndex);
    }

    const emptyState = () => {
        setOISelected([]);
        setOPSelected([]);
        setCISelected([]);
        setCPSelected([]);
        setOIMarkedAmount(0);
        setOPMarkedAmount(0);
        setCIMarkedAmount(0);
        setCPMarkedAmount(0);
        reverseFunction([]);
        settleFunction([], []);
        settleAmountFunction(0, 0, 0, 0);
        openInvoiceDetails?.length > 0 && openInvoiceDetails?.map((element, i) => {
            element.costAmount = 0;
            let mLines = { ...element };
            return openInvoiceDetails.splice(i, 1, mLines);
        });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            emptyState();
        }
    }, [createDetails]);

    const calculatePayment = (e, data, invoiceId, table = 'openInvoice') => {
        let mLines = [];
        for (const [key, value] of Object.entries(data)) {
            mLines[key] = value
        }

        if (e.target.name === 'costAmount' && e.target.value !== '') {
            if (parseFloat(e.target.value) <= parseFloat(data.balance)) {
                mLines['costAmount'] = parseFloat(e.target.value);
            } else {
                mLines['costAmount'] = parseFloat(data.balance);
            }
        } else {
            if (e.target.checked) {
                mLines['costAmount'] = parseFloat(data.balance);
            } else {
                mLines['costAmount'] = 0;
            }
        }

        mLines['calcAmount'] = mLines['costAmount'];

        if (table === 'openInvoice') {
            let index = openInvoiceDetails.findIndex((d, i) => invoiceId === i);
            if (index >= 0) {
                openInvoiceDetails.splice(index, 1, mLines);
            }
        } else if (table === 'openPayment') {
            let index = openPaymentDetails.findIndex((d, i) => invoiceId === i);
            if (index >= 0) {
                openPaymentDetails.splice(index, 1, mLines);
            }
        }
        calculateOpenMarkedAmount(openInvoiceDetails, openPaymentDetails);
    }

    const calculateOpenMarkedAmount = (openInvoiceDetails = [], openPaymentDetails = [], newSelected = [], closePaymentDetails = []) => {
        let OIMarkedAmount = openInvoiceDetails.reduce((a, v) => a = a + parseFloat(v.costAmount ? v.costAmount : 0), 0);
        setOIMarkedAmount(parseFloat(OIMarkedAmount));

        let OPMarkedAmount = openPaymentDetails.reduce((a, v) => a = a + parseFloat(v.costAmount ? v.costAmount : 0), 0);
        setOPMarkedAmount(parseFloat(OPMarkedAmount));


        let CPMarkedAmount = closePaymentDetails.reduce((a, v) => a = a + parseFloat(v.settledAmount ? v.settledAmount : 0), 0);
        setCPMarkedAmount(parseFloat(CPMarkedAmount));

        let invoicesArray = [];
        closePaymentDetails && closePaymentDetails.map(function (element, i) {
            invoicesArray.push(...element.invoices.filter(function (el) { return newSelected.find(e => e === el.invoiceId) }));
        });

        let CIMarkedAmount = invoicesArray.reduce((a, v) => a = a + parseFloat(v.settlementAmount ? v.settlementAmount : 0), 0);
        setCIMarkedAmount(parseFloat(CIMarkedAmount));

        settleAmountFunction(parseFloat(OIMarkedAmount), parseFloat(OPMarkedAmount), parseFloat(CIMarkedAmount), parseFloat(CPMarkedAmount));
    }

    const isOIselected = (name) => OIselected.indexOf(name) !== -1;
    const isOPselected = (name) => OPselected.indexOf(name) !== -1;
    const isCIselected = (name) => CIselected.indexOf(name) !== -1;
    const isCPselected = (name) => CPselected.indexOf(name) !== -1;


    const classes = customStyles();
    return (
        <>
            <TabContext value={value}>
                <Box className={classes.tabDesign}>
                    <TabList onChange={handleChange}>
                        <Tab className={classes.Bordertab_1} onClick={() => setOpenTransaction()} label="Open Transactions" value={1} />
                        <Tab className={classes.Bordertab_2} onClick={() => setClosedTransaction()} label="Closed Transactions" value={2} />
                    </TabList>
                    <div className={classes.tabWrap}>
                        <Typography className={clsx(classes.fontsize14, classes.bold, classes.disInline)}><span className={classes.colorLine} >{customerDetails?.name || '---'}</span> {customerDetails?.serialNo || '---'}</Typography>
                        <Typography variant={'subtitle1'} className={clsx(classes.padding0, classes.disInline, classes.fonSize13)}>Date - {moment().format('DD MMM YYYY')}</Typography>
                    </div>
                </Box>
                <TabPanel value={1}>
                    <Row gutter={30} className={clsx(classes.scrollParent)}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className={classes.scrollParentSettleMent}>
                            <Row>
                                <Col span={7}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.ellipse)}>Open Invoices</Typography>
                                </Col>
                                <Col span={17} className={classes.textAlignRight}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.disInline)}>Marked Amnt. </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.disInline, classes.amountBorder2)}><span >₹ {currencyFormat(OIMarkedAmount)}</span></Typography>
                                </Col>
                            </Row>
                            <Row className={clsx(classes.customRow, classes.margin15t)}>
                                <CustomInfiniteScroll
                                    loadMore={oILoadMore}
                                    loadMoreContent={oILoadMoreContent}
                                    heads={openInvoicesHead}
                                    sortOrder={sortOIOrder}
                                    sortBy={sortOIBy}
                                    onRequestSort={(sortBy, sortOrder) => requestOISort(sortBy, sortOrder)}
                                    autoWidth={true}
                                    loadMoreTask={() => loadMoreOpenInvoiceTask()}
                                    component={<>
                                        {
                                            !oILoadMore || openInvoiceDetails === '' ? (
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={openInvoicesHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow>) : (<React.Fragment>
                                                    {
                                                        openInvoiceDetails && Array.isArray(openInvoiceDetails) && openInvoiceDetails.length > 0 ? openInvoiceDetails.map((data, i) => (
                                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}  >
                                                                <TableCell padding="checkbox" className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleOIClick(e, data, i)}>
                                                                    <Checkbox color="primary" checked={isOIselected(data.id)} />
                                                                </TableCell>
                                                                <TableCell>{data.type === 'PAYMENT REVERSAL' && data?.customerPayment.serialNo}{(data.type === 'SALES SELF-BILL' || data.type === 'STORE SALES INVOICE') && data?.salesInvoice.serialNo}</TableCell>
                                                                <TableCell>{data?.salesInvoice?.invoiceDate ? moment(data?.salesInvoice?.invoiceDate).format('DD MMM YYYY') : '---'}</TableCell>
                                                                <TableCell className={classes.textAlignRight}>₹ {data.amount ? currencyFormat(data.amount) : '0.00'}</TableCell>
                                                                <TableCell>{data.date ? moment(data.date).format('DD MMM YYYY') : '---'}</TableCell>
                                                                <TableCell className={classes.textAlignRight}>₹ {data.balance ? currencyFormat(data.balance) : '0.00'}</TableCell>
                                                                <TableCell>
                                                                    <TextField autoComplete='one-time-code'
                                                                        // maxRows={3}
                                                                        fullWidth
                                                                        type={'number'}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        name="costAmount"
                                                                        value={data.costAmount && data.costAmount > 0 ? data.costAmount : (OIselected.find(e => e === data.id) ? "" : 0)}
                                                                        //value={data.costAmount ? data.costAmount : 0}
                                                                        className={clsx(classes.textAreaAdjust, classes.settledAmount, { [classes.dataCostAmountText]: OIselected.find(e => e === data.id) })}
                                                                        //multiline={true}
                                                                        onChange={(e) => handleCostAmount(e, data, i)}
                                                                        InputProps={{
                                                                            startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                            classes: {
                                                                                input: classes.textFieldColor,
                                                                            },
                                                                            step: "any"
                                                                        }}
                                                                        InputLabelProps={{
                                                                            className: classes.textAreaLableColorCustom,
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell className={classes.textAlignCenter} colSpan={openInvoicesHead.length + 1}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'There are No Open Invoices for Settlement'}</p></TableCell>
                                                        </TableRow>
                                                    }
                                                </React.Fragment>
                                            )
                                        }
                                    </>
                                    }
                                />
                            </Row>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Row>
                                <Col span={7}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.ellipse)}>Open Credits & Payments</Typography>
                                </Col>
                                <Col span={17} className={classes.textAlignRight}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.disInline)}>Marked Amnt. </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.disInline, classes.amountBorder2)}><span>₹ {currencyFormat(OPMarkedAmount)}</span></Typography>
                                </Col>
                            </Row>
                            <Row className={clsx(classes.customRow, classes.margin15t)}>
                                <CustomInfiniteScroll
                                    loadMore={oPLoadMore}
                                    loadMoreContent={oPLoadMoreContent}
                                    heads={openCreditsHead}
                                    sortOrder={sortOPOrder}
                                    sortBy={sortOPBy}
                                    autoWidth={true}
                                    onRequestSort={(sortBy, sortOrder) => requestOPSort(sortBy, sortOrder)}
                                    loadMoreTask={() => loadMoreOpenPaymentTask()}
                                    component={<>
                                        {
                                            !oPLoadMore || openPaymentDetails === '' ? (
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={openCreditsHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow>) : (<React.Fragment>
                                                    {
                                                        openPaymentDetails && Array.isArray(openPaymentDetails) && openPaymentDetails.length > 0 ? openPaymentDetails.map((data, i) => (
                                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                                <TableCell padding="checkbox" className={clsx('checkbox', classes.tablealign, `${OPselected.length > 0 && !isOPselected(data.id) ? classes.disabled : ''}`)} onClick={(e) => handleOPClick(e, data, i)}>
                                                                    <Checkbox color="primary" checked={isOPselected(data.id)} />
                                                                </TableCell>
                                                                <TableCell>{data.type === 'PAYMENT' && data?.customerPayment.serialNo}{(data.type === 'INVOICE CANCEL' || data.type === 'SELF BILL-CREDIT NOTE') && data?.salesInvoice.serialNo}</TableCell>
                                                                <TableCell>{data?.customerPayment?.date ? moment(data?.customerPayment?.date).format('DD MMM YYYY') : moment(data?.documentDate).format('DD MMM YYYY')}</TableCell>
                                                                <TableCell className={classes.textAlignRight}>₹ {data.amount ? currencyFormat(data.amount) : '0.00'}</TableCell>
                                                                <TableCell>{data.date ? moment(data.date).format('DD MMM YYYY') : '---'}</TableCell>
                                                                <TableCell className={classes.textAlignRight}>₹ {data.balance ? currencyFormat(data.balance) : '0.00'}</TableCell>
                                                                {/* <TableCell>{data?.description || '---'}</TableCell> */}
                                                            </TableRow>
                                                        )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell className={classes.textAlignCenter} colSpan={openCreditsHead.length + 1}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'There are No Open Credits & Payments for Settlement'}</p></TableCell>
                                                        </TableRow>
                                                    }
                                                </React.Fragment>
                                            )
                                        }
                                    </>
                                    }
                                />
                            </Row>
                        </Col>
                    </Row>
                </TabPanel>
                <TabPanel value={2}>
                    <Row gutter={30} className={clsx(classes.scrollParent)}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className={classes.scrollParentSettleMent}>
                            <Row>
                                <Col span={7}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.ellipse)}> Settled Invoices</Typography>
                                </Col>
                                <Col span={17} className={classes.textAlignRight}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.disInline)}>Marked Amnt. </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.disInline, classes.amountBorder2)}><span>₹ {currencyFormat(CIMarkedAmount)}</span></Typography>
                                </Col>
                            </Row>
                            <Row className={clsx(classes.customRow, classes.margin15t)}>
                                <PrimaryTable
                                    heads={settledInvoicesHead}
                                    onRequestSort={(sortBy, sortOrder) => requestCISort(sortBy, sortOrder)}
                                    sortOrder={sortCIOrder}
                                    sortBy={sortCIBy}
                                    // width={true}
                                    details={closeInvoiceDetails}
                                    selected={CIselected}
                                    onSelected={(value) => setCISelected(value)}
                                    component={
                                        <>
                                            {
                                                closeInvoiceLoader === false && closeInvoiceDetails && closeInvoiceDetails?.length > 0 && closeInvoiceDetails?.map((element, i) => (
                                                    element?.invoices.map((data, i) => (
                                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                            {
                                                                (element?.settlementType === 'PAYMENT') ? <TableCell padding="checkbox" className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleCIClick(e, data, element)}>
                                                                    <Checkbox color="primary" checked={isCIselected(data.invoiceId + '_' + element.paymentId)} />
                                                                </TableCell> : <TableCell padding="checkbox" className={clsx('checkbox', classes.tablealign)}>
                                                                    <Checkbox color="primary" disabled={true} />
                                                                </TableCell>
                                                            }
                                                            <TableCell>{data.invoiceSerialNo ? data.invoiceSerialNo : '---'}</TableCell>
                                                            <TableCell>{data.invoiceDate ? moment(data.invoiceDate).format('DD MMM YYYY') : '---'}</TableCell>
                                                            <TableCell className={classes.textAlignRight}>₹ {data.invoiceAmount ? currencyFormat(data.invoiceAmount) : '0.00'}</TableCell>
                                                            <TableCell>{data.settlementDate ? moment(data.settlementDate).format('DD MMM YYYY') : '---'}</TableCell>
                                                            <TableCell className={classes.textAlignRight}><span>₹ {data.settlementAmount ? currencyFormat(data.settlementAmount) : '0.00'}</span></TableCell>
                                                        </TableRow>
                                                    ))
                                                ))
                                            }
                                            {
                                                closeInvoiceLoader === false && closeInvoiceDetails && closeInvoiceDetails.length === 0 && (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={6}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'There are No Settled Invoices'}</p></TableCell>
                                                    </TableRow>
                                                )
                                            }
                                            {
                                                closeInvoiceLoader === true && (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </>
                                    }
                                />
                            </Row>

                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Row>
                                <Col span={7}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold, classes.ellipse)}>Settled Credits & Payments</Typography>
                                </Col>
                                <Col span={17} className={classes.textAlignRight}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, classes.disInline)}>Marked Amnt. </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.disInline, classes.amountBorder2)}><span >₹ {currencyFormat(CPMarkedAmount)}</span></Typography>
                                </Col>
                            </Row>
                            <Row className={clsx(classes.customRow, classes.margin15t)}>
                                <PrimaryTable
                                    heads={settledCreditsHead}
                                    sortOrder={sortCIOrder}
                                    sortBy={sortCIBy}
                                    onRequestSort={(sortBy, sortOrder) => requestCISort(sortBy, sortOrder)}
                                    details={closePaymentDetails}
                                    selected={CPselected}
                                    onSelected={(value) => setCPSelected(value)}
                                    component={
                                        <>
                                            {
                                                closeInvoiceLoader === false && closeInvoiceDetails && closeInvoiceDetails.length > 0 && closeInvoiceDetails.map((data, i) => (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                        {
                                                            (data?.settlementType === 'PAYMENT') ? <TableCell padding="checkbox" className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleCPClick(e, data)}>
                                                                <Checkbox color="primary" checked={isCPselected(data.paymentId)} />
                                                            </TableCell> : <TableCell padding="checkbox" className={clsx('checkbox', classes.tablealign)}>
                                                                <Checkbox color="primary" disabled={true} />
                                                            </TableCell>
                                                        }
                                                        <TableCell>{data.paymentSerialNo ? data.paymentSerialNo : '---'}</TableCell>
                                                        <TableCell>{data.paymentDate ? moment(data.paymentDate).format('DD MMM YYYY') : '---'}</TableCell>
                                                        <TableCell className={classes.textAlignRight}><span className={classes.customCurreny}>₹ {data.paymentAmount ? currencyFormat(data.paymentAmount) : '0.00'}</span></TableCell>
                                                        <TableCell>{data.settledDate ? moment(data.settledDate).format('DD MMM YYYY') : '---'}</TableCell>
                                                        <TableCell><span className="customCurreny">₹ {data.settledAmount ? currencyFormat(data.settledAmount) : '0.00'}</span></TableCell>
                                                        {/* <TableCell></TableCell> */}
                                                    </TableRow>
                                                ))
                                            }
                                            {
                                                closeInvoiceLoader === false && closeInvoiceDetails && closeInvoiceDetails.length === 0 && (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={6}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'There are No Settled Credits & Payments'}</p></TableCell>
                                                    </TableRow>
                                                )
                                            }
                                            {
                                                closeInvoiceLoader === true && (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                                    </TableRow>
                                                )
                                            }

                                        </>
                                    }
                                />
                            </Row>
                        </Col>
                    </Row>
                </TabPanel>
            </TabContext>
        </>
    )
})
